"use client";

import { FormattedMedia } from "@frend-digital/centra/formatting";
import clsx from "clsx";
import Image, { ImageProps } from "next/image";
import { Dispatch, SetStateAction } from "react";
import styles from "./index.module.css";

/**
 * Extension of Next Image with fill that allows zooming in on the image
 */

export interface ZoomProps {
  setCurrent: Dispatch<SetStateAction<number>>;
  current: number;
  media: FormattedMedia[];
  setZoom: Dispatch<SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setSecondSwiper?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firstSwiper?: any;
}

const ZoomImage = ({
  setZoom,
  src,
  className,
  alt,
  fill: _,
  setCurrent: __,
  media: ___,
  ...rest
}: ImageProps & ZoomProps) => {
  const fill = true;
  return (
    <>
      <figure>
        <span title="show zoomed" aria-hidden onClick={() => setZoom(true)}>
          <Image
            src={src}
            fill={fill}
            className={clsx(styles.image, className)}
            alt={alt}
            {...rest}
          />
        </span>
      </figure>
    </>
  );
};

export default ZoomImage;
